import { Box, Grid } from "@mui/material";
import axios from "axios";
import Typography from "components/common/Typography";
import { debounce, isEmpty } from "lodash";
import { useCallback, useState } from "react";
import { Mention, MentionsInput } from "react-mentions";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getAPIHeaders } from "utils/APIHelper";
import { PAGE_SIZE, messages, minSearchStrLength } from "utils/CommonConstants";
import { createParamforSearch } from "utils/CommonFunctions";
import { USER_SERVICE } from "utils/URLConstants";

export const MentionInput = (props: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pageNo] = useState(0);
  const myPlanDetails: any = useAppSelector((state: any) => state.myPlanDetails.myPlanDetails);
  const isAdmin = useAppSelector((state) => state.app.isAdmin);
  const [showNoResultsMsg, setShowNoResultsMsg] = useState(false);
  const handleChange = (e: any, v: any) => {
    setShowNoResultsMsg(false);
    props.setCommentValue(v);
  };

  const getDisplayValue = (id: any, display: any) => {
    return `@${display.split("(")[0]}`;
  };

  const fetchUsers = useCallback(
    debounce((query: any, callback: any) => {
      if (query.length > minSearchStrLength) {
        setIsLoading(true);
        const URL = `${USER_SERVICE}associates/?page=${pageNo}&size=${PAGE_SIZE}&searchText=${query}&innCodes=${createParamforSearch(
          isAdmin,
          myPlanDetails?.innCode
        )}`;
        const requestHeaders = getAPIHeaders();
        if (!query) return;

        axios
          .get(`${URL}`, {
            headers: requestHeaders
          })
          .then((res) => {
            setIsLoading(false);
            query.length > 2 && isEmpty(res.data.users) ? setShowNoResultsMsg(true) : setShowNoResultsMsg(false);
            return res.data.users.map((user: any) => ({
              display: `${user.firstName ? user.firstName : ""} ${user.lastName ? user.lastName : ""} ${
                user.email ? "(" + user.email + ")" : ""
              }`,
              id: user.hltId
            }));
          })
          .then(callback)
          .catch((error) => {
            setIsLoading(false);
            setShowNoResultsMsg(true);
            console.log("Error", error);
          });
      }
    }, 500),
    []
  );

  const inputStyles = {
    width: "100%",
    marginLeft: "5px",
    control: {},

    "&multiLine": {
      control: {
        minHeight: 63
      },
      highlighter: {
        overflow: "auto",
        padding: 9
      },
      input: {
        padding: 9,
        border: `1px solid ${tokens.Border.General.Secondary}`,
        borderRadius: "5px",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "21px",
        overflow: "auto"
      }
    },

    "&singleLine": {
      display: "inline-block",
      width: 180,

      highlighter: {
        padding: 1,
        border: "2px inset transparent"
      },
      input: {
        padding: 1
      }
    },

    suggestions: {
      maxHeight: "80px",
      overflow: "auto",
      border: `1px solid ${tokens.Border.General.Tertiary}`,
      boxShadow: "0px 10px 25px rgba(100, 116, 139, 0.1), 0px 20px 40px 8px rgba(100, 116, 139, 0.3)",
      list: {
        fontSize: 14
      },
      item: {
        padding: "5px 15px",
        "&focused": {
          backgroundColor: `${tokens.Draggable.General.DraggedItem}`,
          color: `${tokens.Text.General.Color}`
        }
      }
    }
  };

  return (
    <Grid container>
      <Box sx={{ width: "100%" }}>
        <MentionsInput
          value={props.commentValue}
          onChange={handleChange}
          style={inputStyles}
          allowSuggestionsAboveCursor
          placeholder="Search any user by typing `@` followed by at least one char"
        >
          <Mention
            appendSpaceOnAdd
            markup="[{~__display__~}][~~__id__~~]"
            displayTransform={getDisplayValue}
            trigger="@"
            data={fetchUsers}
          />
        </MentionsInput>
      </Box>

      {isLoading ? (
        <Typography variant={"label"}>Loading...</Typography>
      ) : (
        showNoResultsMsg && (
          <Box sx={{ padding: "8px" }}>
            <Typography component={"div"} variant={"label"}>
              {messages.userNotFound}
            </Typography>
          </Box>
        )
      )}
    </Grid>
  );
};
